const EMAIL_CATEGORIES = [
    { key: "summaries", label: "Summaries & digests", hint: "Weekly/fortnightly summaries, Pulse, daily digest" },
    { key: "reminders", label: "Reminders", hint: "Due/overdue chasers for reports, actions, RAMS, equipment" },
    { key: "reviews", label: "Review requests", hint: "Something needs your review or approval" },
    { key: "assigned", label: "Assigned to me", hint: "Something assigned or addressed directly to you" },
];

// value = the user's OPTED-OUT categories (empty = everything on, the default).
export function EmailNotificationSwitches({ value = [], onChange }) {
    const isOn = (key) => !value.includes(key);
    const toggle = (key) => onChange(isOn(key) ? [...value, key] : value.filter((c) => c !== key));
    return (
        <div className="space-y-2" data-testid="email-notification-switches">
            <p className="text-[11px] font-semibold uppercase tracking-wide" style={{ color: "#9A968F" }}>Email notifications</p>
            {EMAIL_CATEGORIES.map((c) => (
                <label key={c.key} className="flex items-start gap-2 text-[12.5px] font-medium text-[#2D2D2D]">
                    <input data-testid={`email-notif-${c.key}`} type="checkbox" className="mt-0.5" checked={isOn(c.key)} onChange={() => toggle(c.key)} />
                    <span>{c.label}<span className="block text-[11px] font-normal" style={{ color: "#9A968F" }}>{c.hint}</span></span>
                </label>
            ))}
        </div>
    );
}
